import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import SpecialCMCardImage from '../../assets/images/events/event2.jpg'

import SpecialCMCardContent from './SpecialCMCardContent'

const SpecialCMCardStyle = styled.div`
  background-color: #EDEEF3;
  overflow: hidden;
  position: relative;
  box-shadow: 0px 5px 20px 5px rgba(160,160,160,0.6);
`;

export default class SpecialCMCard extends React.Component {
  render() {
    return (
      <Link to="/events/event2/">
        <SpecialCMCardStyle>
          <SpecialCMCardContent />
          <SpecialCMCardImg />
        </SpecialCMCardStyle>
      </Link>
    )
  }
}

const SpecialCMCardImgStyle = styled.div`
  line-height: 0;

  .specialCMCardImgShadow {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9999;

    background: rgba(10,10,10,0.31);
    background: -moz-linear-gradient(-45deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    background: -webkit-gradient(left top, right bottom, color-stop(0%, rgba(10,10,10,0.31)), color-stop(100%, rgba(10,10,10,0)));
    background: -webkit-linear-gradient(-45deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    background: -o-linear-gradient(-45deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    background: -ms-linear-gradient(-45deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    background: linear-gradient(135deg, rgba(10,10,10,0.31) 0%, rgba(10,10,10,0) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0a0a0a', endColorstr='#0a0a0a', GradientType=1 );
  }

  img {
    width: 100%;
  }
`;

class SpecialCMCardImg extends React.Component {
  render() {
    return (
      <SpecialCMCardImgStyle>
        <div className="specialCMCardImgShadow"></div>
        <img src={SpecialCMCardImage} alt="Special Camminando Mangiando X"/>
      </SpecialCMCardImgStyle>
    )
  }
}